<template>
  <v-select
    :items="expenseAmountTypes"
    item-value="id"
    item-text="expenseAmountType"
    v-model="expenseAmountTypeIdValue"
    :clearable="clearable ? clearable : false"
    label="Amount Type"
    :rules="[requiredCheck()]"
    outlined
  ></v-select>
</template>

<script>
import { required } from '@/lib/formValidations'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'

export default {
  props: [
    'expenseAmountTypeId',
    'isRequired',
    'clearable'
  ],
  computed: {
    ...mapFields('expenseAmountTypes',
      ['expenseAmountTypes']),
    expenseAmountTypeIdValue: {
      get () {
        return this.expenseAmountTypeId
      },
      set (newExpenseAmountTypeId) {
        this.$emit('expenseAmountTypeIdChange', newExpenseAmountTypeId)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required('Amount Type')
    },
    ...mapActions('expenseAmountTypes',
      ['getExpenseAmountTypes'])
  },
  created () {
    this.getExpenseAmountTypes()
  }
}
</script>
